import { useEffect, useState } from "react";
import { marketingApi } from "@/lib/marketing";

export default function SettingsTab() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    marketingApi.getSettings().then(setSettings).catch(() => {});
  }, []);

  if (!settings) return <p className="font-body text-ink-soft">Loading…</p>;

  return (
    <div className="bg-paper border border-ink/12 p-6 space-y-6 max-w-2xl" data-testid="settings-tab">
      <p className="font-body text-xs uppercase tracking-[0.14em] text-terracotta">V1 — read-only</p>
      <div>
        <p className="font-body text-xs uppercase tracking-wide text-ink-soft">Configured short-link domain</p>
        <p className="font-serif text-xl text-ink" data-testid="settings-short-domain">{settings.short_link_base_url}</p>
      </div>
      <div>
        <p className="font-body text-xs uppercase tracking-wide text-ink-soft mb-1">Purposes</p>
        <p className="font-body text-sm text-ink" data-testid="settings-purposes">{settings.purposes.join(", ")}</p>
      </div>
      <div>
        <p className="font-body text-xs uppercase tracking-wide text-ink-soft mb-1">Statuses</p>
        <p className="font-body text-sm text-ink" data-testid="settings-statuses">{settings.statuses.join(", ")}</p>
      </div>
      <div>
        <p className="font-body text-xs uppercase tracking-wide text-ink-soft mb-1">Delivery methods</p>
        <p className="font-body text-sm text-ink" data-testid="settings-delivery-methods">{settings.delivery_methods.join(", ")}</p>
      </div>
      <div>
        <p className="font-body text-xs uppercase tracking-wide text-ink-soft mb-2">Paid Ads platforms</p>
        <table className="w-full text-sm" data-testid="settings-paid-ad-platforms">
          <tbody>
            {settings.paid_ad_platforms.map((p) => (
              <tr key={p.id} className="border-b border-ink/10">
                <td className="font-body text-ink py-1.5">{p.label}</td>
                <td className="font-body text-ink-soft py-1.5">{p.click_id_param}</td>
                <td className="font-body text-ink-soft py-1.5">{p.macro || "auto-appended by platform"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        <p className="font-body text-xs uppercase tracking-wide text-ink-soft mb-1">Service identity scopes</p>
        <p className="font-body text-sm text-ink" data-testid="settings-scopes">{settings.service_identity_scopes.join(", ")}</p>
      </div>
    </div>
  );
}
